import { render, staticRenderFns } from "./BattleInfo.vue?vue&type=template&id=66600070&scoped=true&"
import script from "./BattleInfo.vue?vue&type=script&lang=ts&"
export * from "./BattleInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BattleInfo.vue?vue&type=style&index=0&id=66600070&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66600070",
  null
  
)

export default component.exports